import { Cookies } from "react-cookie";
import printService from "services/printService";

export const printTag = async ({ sku, data, batchExternalCode, printer }) => {
  const uniqueTag = data.prePicking === 1 || data.prePicking === 2;
  const {
    sku: skuId,
    name: skuName,
    purchaseValue,
    product_base: productBase
  } = sku;
  const cookies = new Cookies();
  const distributionCenterId = cookies.get("distributionCenterId");
  try {
    await printService.printTagsV2({
      sku: skuId,
      skuName,
      portionType: sku.portionType,
      purchaseValue,
      productBaseId: productBase.id,
      productBaseName: productBase.name,
      tagQuantity: data.amountOfTags,
      batchId: data.batchId,
      batchExternalCode,
      uniqueTag,
      printer,
      distributionCenterId
    });
  } catch (error) {
    const errorData = error?.response?.data;
    throw new Error(errorData?.message || errorData?.msg);
  }
};
